/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment, memo, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Space, Typography } from 'antd';
import NodeWrapper from '../../NodeWrapper';
import { GraphContext } from '../../FlowGraph';
import { GRAPH_LAYOUTS } from '../../../../constants/flowGraph';
import LimitedConnectionsHandle from '../../LimitedConnectionsHandle';

// Misc imports
import { NODE_TYPES_PROPERTIES } from '../../../../constants/flowGraph';
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';

// Constant declarations
const { Text } = Typography;

const MultiOptionNode = ({ id, type, data, dragging, selected }) => {
  const nodeProps = NODE_TYPES_PROPERTIES[type];
  const { t } = useTranslation();
  const { graphDirection } = useContext(GraphContext);
  const { currentBotLanguage } = useBotLanguage();

  const NodeContents = useMemo(() => {
    return (
      <Fragment>
        <LimitedConnectionsHandle type="target" position={graphDirection === GRAPH_LAYOUTS.VERTICAL ? 'top' : 'left'}/>

        <Space size={6} className="node-header">
          {nodeProps.icon}
          {nodeProps.label}
        </Space>

        <Text type="secondary">
          {t('Click to edit options')}
        </Text>

        <LimitedConnectionsHandle id={id} type="source" position={graphDirection === GRAPH_LAYOUTS.VERTICAL ? 'bottom' : 'right'} allowedOutgoingEdgesCount={1} />
      </Fragment>
    );
  }, [data, nodeProps, graphDirection, currentBotLanguage]);

  return (
    <NodeWrapper
      id={id}
      type={type}
      data={data}
      children={NodeContents}
      dragging={dragging}
      selected={selected}
    />
  );
};

// https://reactflow.dev/docs/api/nodes/node-options/
MultiOptionNode.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  dragging: PropTypes.bool,
  selected: PropTypes.bool,
  type: PropTypes.string,
  xPos: PropTypes.number,
  yPos: PropTypes.number
};

export default memo(MultiOptionNode);
